import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mod mod-table skin-calculator-table-baudarlehen"
}
const _hoisted_2 = { class: "table section" }
const _hoisted_3 = { class: "header-wrapper" }
const _hoisted_4 = {
  href: "#",
  title: "Kürzere Sollzinsbindung"
}
const _hoisted_5 = { class: "tr headline" }
const _hoisted_6 = { class: "th" }
const _hoisted_7 = { class: "tr header" }
const _hoisted_8 = { class: "th" }
const _hoisted_9 = { class: "info-wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "info"
}
const _hoisted_11 = {
  href: "#",
  title: "Längere Sollzinsbindung"
}
const _hoisted_12 = { class: "tr" }
const _hoisted_13 = { class: "th" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "tr" }
const _hoisted_16 = { class: "th" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "tr" }
const _hoisted_19 = { class: "th" }
const _hoisted_20 = { class: "table" }
const _hoisted_21 = { class: "tr" }
const _hoisted_22 = { class: "th" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "tr" }
const _hoisted_25 = { class: "th" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "tr" }
const _hoisted_28 = { class: "th" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "tr" }
const _hoisted_31 = { class: "th" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "tr" }
const _hoisted_34 = { class: "th" }
const _hoisted_35 = { class: "tr" }
const _hoisted_36 = { class: "th" }
const _hoisted_37 = { class: "tr" }
const _hoisted_38 = { class: "th" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "tr" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "tr" }
const _hoisted_44 = { class: "th" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { class: "tr" }
const _hoisted_47 = { class: "th" }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = { class: "table-footer-wrapper cf" }
const _hoisted_50 = {
  href: "#",
  title: "Kürzere Sollzinsbindung"
}
const _hoisted_51 = {
  href: "#",
  title: "Längere Sollzinsbindung"
}
const _hoisted_52 = { class: "legal" }
const _hoisted_53 = {
  key: 1,
  class: "loadingscreen"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("p", null, "Vergleichsberechnungen werden geladen...", -1)
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_base = _resolveComponent("icon-base")!
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_klapper = _resolveComponent("klapper")!

  return (!_ctx.isCalculating)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("div", {
              class: "nav back",
              style: {"display":"inline-block"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPreviousClicked && _ctx.onPreviousClicked(...args)))
            }, [
              _createElementVNode("a", _hoisted_4, [
                _createVNode(_component_icon_base, {
                  type: "icon",
                  name: "double_arrow",
                  "additional-css-classes": "icon--small icon--rotate-270"
                })
              ])
            ], 512), [
              [_vShow, _ctx.hasPrevious]
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.textHeading), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.textSollzinsbindungGebunden), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                  key: detail.sollzinsbindung.jahre
                }, [
                  _createElementVNode("span", _hoisted_9, [
                    _createTextVNode(_toDisplayString(detail.sollzinsbindung.jahre + ' Jahre') + " ", 1),
                    (_ctx.isSelected(detail.sollzinsbindung.jahre))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Berechnetes Darlehen"))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ]),
            _withDirectives(_createElementVNode("div", {
              class: "nav next",
              style: {"display":"inline-block"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNextClicked && _ctx.onNextClicked(...args)))
            }, [
              _createElementVNode("a", _hoisted_11, [
                _createVNode(_component_icon_base, {
                  type: "icon",
                  name: "double_arrow",
                  "additional-css-classes": "icon--small icon--rotate-90"
                })
              ])
            ], 512), [
              [_vShow, _ctx.hasNext]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.textEffektiverJahreszins), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                key: detail.sollzinsbindung.jahre
              }, [
                _createElementVNode("span", {
                  innerHTML: _ctx.convertNumberToHtmlWithTwoDigitsAndSuffixPercent(detail.effektiverJahreszins)
                }, null, 8, _hoisted_14)
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.textHoeheMonatlicheRate), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                key: detail.sollzinsbindung.jahre
              }, [
                _createElementVNode("span", {
                  innerHTML: _ctx.convertNumberToHtmlWithTwoDigitsAndSuffixEuro(detail.hoeheMonatlicheRate)
                }, null, 8, _hoisted_17),
                _createVNode(_component_tooltip, {
                  text: _ctx.getTooltipRate(detail)
                }, null, 8, ["text"])
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.textGesamtlaufzeit), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                key: detail.sollzinsbindung.jahre
              }, _toDisplayString(_ctx.getFormattedLaufzeit(detail.gesamtlaufzeit)), 3))
            }), 128))
          ]),
          _createVNode(_component_klapper, {
            "is-open": false,
            title: _ctx.textHeadingKlapper,
            "show-edit-icon": false,
            "tracking-action": "2_ergebnis_baudarlehen_vergleich_klapper_details"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.textRestschuld), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                      key: detail.sollzinsbindung.jahre
                    }, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.convertNumberToHtmlWithTwoDigitsAndSuffixEuro(detail.restschuldZinsbindungsende)
                      }, null, 8, _hoisted_23),
                      _createVNode(_component_tooltip, {
                        text: _ctx.getHinweisEndfaelligkeit(detail),
                        color: "primary"
                      }, null, 8, ["text"])
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.textZuZahlenderGesamtbetrag), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                      key: detail.sollzinsbindung.jahre
                    }, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.convertNumberToHtmlWithTwoDigitsAndSuffixEuro(detail.zuZahlenderGesamtbetrag)
                      }, null, 8, _hoisted_26)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.textNettodarlehen), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                      key: detail.sollzinsbindung.jahre
                    }, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.convertNumberToHtmlWithTwoDigitsAndSuffixEuro(detail.nettodarlehen)
                      }, null, 8, _hoisted_29)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.textJaehrlicheSollzinsbindung), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                      key: detail.sollzinsbindung.jahre
                    }, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.convertNumberToHtmlWithTwoDigitsAndSuffixPercent(detail.jaehrlicherSollzinssatz)
                      }, null, 8, _hoisted_32)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.textSollzinsbindung), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                      key: detail.sollzinsbindung.jahre
                    }, _toDisplayString(_ctx.getFormattedLaufzeit(detail.sollzinsbindung)), 3))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.textAnzahlRaten), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                      key: detail.sollzinsbindung.jahre
                    }, _toDisplayString(detail.anzahlRaten), 3))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.textTilgungssatz), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                      key: detail.sollzinsbindung.jahre
                    }, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.convertNumberToHtmlWithTwoDigitsAndSuffixPercent(detail.tilgungssatz)
                      }, null, 8, _hoisted_39)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.textGesamtkosten,
                    class: "th"
                  }, null, 8, _hoisted_41),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                      key: detail.sollzinsbindung.jahre
                    }, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.convertNumberToHtmlWithTwoDigitsAndSuffixEuro(detail.gesamtkosten)
                      }, null, 8, _hoisted_42)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.textEintragungskostenGrundbuch), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                      key: detail.sollzinsbindung.jahre
                    }, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.convertNumberToHtmlWithTwoDigitsAndSuffixEuro(detail.eintragungskostenGrundbuch)
                      }, null, 8, _hoisted_45)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.textFinanzierungsmodell), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsToDisplay, (detail) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["td", [_ctx.isSelected(detail.sollzinsbindung.jahre)? 'defaultSollzinsbindung': '']]),
                      key: detail.sollzinsbindung.jahre
                    }, _toDisplayString(detail.finanzierungsmodell), 3))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", { innerHTML: _ctx.textFussnote }, null, 8, _hoisted_48)
            ]),
            _: 1
          }, 8, ["title"]),
          _createElementVNode("div", _hoisted_49, [
            _withDirectives(_createElementVNode("div", {
              class: "nav back",
              style: {"display":"inline-block"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPreviousClicked && _ctx.onPreviousClicked(...args)))
            }, [
              _createElementVNode("a", _hoisted_50, [
                _createVNode(_component_icon_base, {
                  type: "icon",
                  name: "double_arrow",
                  "additional-css-classes": "icon--small icon--rotate-270"
                })
              ])
            ], 512), [
              [_vShow, _ctx.hasPrevious]
            ]),
            _withDirectives(_createElementVNode("div", {
              class: "nav next",
              style: {"display":"inline-block"},
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onNextClicked && _ctx.onNextClicked(...args)))
            }, [
              _createElementVNode("a", _hoisted_51, [
                _createVNode(_component_icon_base, {
                  type: "icon",
                  name: "double_arrow",
                  "additional-css-classes": "icon--small icon--rotate-90"
                })
              ])
            ], 512), [
              [_vShow, _ctx.hasNext]
            ])
          ]),
          _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.textRechtlicherHinweis), 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_56))
}